




















import Vue from 'vue';
import Component from 'vue-class-component';
import helper from '@/services/helper.ts';
import { mapGetters, mapState } from 'vuex';
import api from '@/services/api';
import Q from 'q';
import { Prop } from 'vue-property-decorator';
import { locales } from '@/i18n-setup';

@Component<LocaleSwitcherModal>({
  computed: {
    ...mapState({
      Lang: 'Lang',
    }),
  },
})
export default class LocaleSwitcherModal extends Vue {
  public readonly Lang!: string;
  public readonly locales = locales;

  @Prop() protected readonly name!: string;

  async ChangeLang(lang: string) {
    helper.swalShowLoading();
    let delayPromise = Q.delay(1000);
    let resp = await api.SetLanguage(lang);
    await delayPromise;
    window.location.reload();
  }
}
